import React from "react";
import clsx from "clsx";
import { useLayout } from "../../core";
import { Footer } from "./Footer";
import { useStyleContext } from "../../../helpers/StyleContext";

const FooterWrapper = () => {
  const { config } = useLayout();
  const { styleState } = useStyleContext();

  if (!config.app?.footer?.display) {
    return null;
  }

  return (
    <div
      className="app-footer"
      id="kt_app_footer"
      style={{ backgroundColor: styleState?.footer_background_color }}
    >
      {config.app.footer.containerClass ? (
        <div
          className={clsx("app-container", config.app.footer.containerClass)}
        >
          <Footer />
        </div>
      ) : (
        <Footer />
      )}
    </div>
  );
};

export { FooterWrapper };
